import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { GroupModel, GroupVisibility } from '../types/GroupModel';
import GroupsAPI from '../api/GroupsAPI';

export type GroupsStateType = {
  groups: GroupModel[];
  loading: boolean;
  loaded: boolean;
  error?: string;
};

export const GroupsInitialState: GroupsStateType = {
  groups: [],
  loading: false,
  loaded: false,
};

export const fetchGroups = createAsyncThunk('fetchGroups', async () => {
  return await GroupsAPI.getVisible();
});

export const createGroup = createAsyncThunk(
  'createGroup',
  async (input: { name: string; visibility: GroupVisibility }) => {
    return await GroupsAPI.create(input.name, input.visibility);
  },
);

const slice = createSlice({
  name: 'Groups',
  initialState: GroupsInitialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchGroups.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(fetchGroups.fulfilled, (state, action) => {
      state.loading = false;
      state.loaded = true;
      state.groups = action.payload;
    });
    builder.addCase(fetchGroups.rejected, (state, action) => {
      state.loading = false;
      state.loaded = true;
      state.error = action.error.message;
    });
    // A newly created group joins the list so the switcher and the "add to" selector show it
    // immediately, without a round-trip to refetch.
    builder.addCase(createGroup.fulfilled, (state, action) => {
      if (!state.groups.some((g) => g.Id === action.payload.Id)) {
        state.groups.push(action.payload);
      }
    });
  },
});

export default slice.reducer;
